import React from 'react';
import { getNextApiUrl } from '@/utils/next-api';
import Button, { IButtonProps } from '@/components/Button';

export interface ICompleteRegisterButtonLinkProps extends IButtonProps {}

export const CompleteRegisterButtonLink = (
  props: ICompleteRegisterButtonLinkProps
) => {
  return (
    <a href={getNextApiUrl('auth/complete-register')}>
      <Button
        analytics={['AUTH_COMPLETE_REGISTER']}
        className="col-span-1"
        id="auth_submit_completerRegister"
        isFullWidth
        {...props}
      >
        تکمیل ثبت نام
      </Button>
    </a>
  );
};
